import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import en from "./en";
import ta from "./ta";
import hi from "./hi";
import te from "./te";
import kn from "./kn";
import ml from "./ml";
import es from "./es";
import ru from "./ru";
import zh from "./zh";

export const LANGS = [
  { code: "en", label: "English" }, { code: "ta", label: "தமிழ்" }, { code: "hi", label: "हिन्दी" },
  { code: "te", label: "తెలుగు" }, { code: "kn", label: "ಕನ್ನಡ" }, { code: "ml", label: "മലയാളം" },
  { code: "es", label: "Español" }, { code: "ru", label: "Русский" }, { code: "zh", label: "简体中文" },
];
const DICTS = { en, ta, hi, te, kn, ml, es, ru, zh };
const Ctx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("pf_lang") || (navigator.language || "en").slice(0, 2));
  const safe = DICTS[lang] ? lang : "en";
  const t = useCallback((k) => DICTS[safe][k] ?? en[k] ?? k, [safe]);
  const setLang = useCallback((l) => { localStorage.setItem("pf_lang", l); setLangState(l); }, []);
  useEffect(() => { document.documentElement.lang = safe; }, [safe]);
  return <Ctx.Provider value={{ lang: safe, t, setLang }}>{children}</Ctx.Provider>;
}
export const useI18n = () => useContext(Ctx);
